<template>
  <lite-youtube
    :videoid="videoId"
    :playlabel="playLabel"
    params="rel=0"
    class="rounded-2xl"
  ></lite-youtube>
</template>
<script setup lang="ts">
const props = defineProps<{
  videoId: string;
  title: string;
}>();

const playLabel = "Play: " + props.title;
</script>
